import { Injectable } from '@angular/core';
import {
  TREQUEST_ADD_EDIT_TNA_TEMPLATE_STEP,
  TREQUEST_ASSIGN_TNA_TO_ORDERS,
  TREQUEST_CREATE_TNA_TEMPLATE,
  TREQUEST_DELETE_TNA_TEMPLATE,
  TREQUEST_DELETE_TNA_TEMPLATE_STEP,
  TREQUEST_TNA_TEMPLATE_LISTING,
  TREQUEST_UPDATE_TNA_TEMPLATE_NAME,
} from '@monorepo/types';
import { select, Store } from '@ngrx/store';
import { TPlani8State } from '../reducers';
import * as TnaTemplateActions from './tna-templates.actions';
import * as TnaTemplateSelectors from './tna-templates.selectors';

export const TNA_TEMPLATE_LISTING_ITEMS_PER_PAGE_LIST = [10, 50, 100, 200];
@Injectable({
  providedIn: 'root',
})
export class TnaTemplatesFacade {
  constructor(private store: Store<TPlani8State>) {}

  fetchTnaTemplates(payload: TREQUEST_TNA_TEMPLATE_LISTING) {
    this.store.dispatch(new TnaTemplateActions.GetTnaTemplateList(payload));
  }

  updateTnaTemplateName(
    payload: TREQUEST_UPDATE_TNA_TEMPLATE_NAME,
    fetchTnATemplatesPayload: TREQUEST_TNA_TEMPLATE_LISTING,
  ) {
    this.store.dispatch(new TnaTemplateActions.UpdateTnaTemplateName(payload, fetchTnATemplatesPayload));
  }

  deleteTnaTemplate(payload: TREQUEST_DELETE_TNA_TEMPLATE, fetchTnATemplatesPayload: TREQUEST_TNA_TEMPLATE_LISTING) {
    this.store.dispatch(new TnaTemplateActions.DeleteTnaTemplate(payload, fetchTnATemplatesPayload));
  }

  copyTnaTemplate(templateId: string, fetchTnATemplatesPayload?: TREQUEST_TNA_TEMPLATE_LISTING) {
    this.store.dispatch(new TnaTemplateActions.CopyTnaTemplate(templateId, fetchTnATemplatesPayload));
  }

  setTnaDefaultStepsLoader(showLoader: boolean) {
    this.store.dispatch(new TnaTemplateActions.SetTnaDefaultStepsLoader(showLoader));
  }

  fetchTnADefaultSteps(showLocalLoader?: boolean) {
    this.store.dispatch(new TnaTemplateActions.GetTnaDefaultSteps(showLocalLoader));
  }

  createTnATemplate(payload: TREQUEST_CREATE_TNA_TEMPLATE) {
    this.store.dispatch(new TnaTemplateActions.CreateTnATemplate(payload));
  }

  fetchTnATemplateDetails(templateName: string) {
    this.store.dispatch(new TnaTemplateActions.GetTnaTemplateDetails(templateName));
  }

  clearTnATemplateDetails() {
    this.store.dispatch(new TnaTemplateActions.ClearTnaTemplateDetails());
  }

  downloadTnATemplateDetails(templateId: string) {
    this.store.dispatch(new TnaTemplateActions.DownloadTnaTemplateDetails(templateId));
  }

  addEditTnATemplateStep(payload: TREQUEST_ADD_EDIT_TNA_TEMPLATE_STEP, templateName: string) {
    this.store.dispatch(new TnaTemplateActions.AddEditTnaTemplateStep(payload, templateName));
  }

  deleteTnATemplateStep(payload: TREQUEST_DELETE_TNA_TEMPLATE_STEP, templateName: string) {
    this.store.dispatch(new TnaTemplateActions.DeleteTnaTemplateStep(payload, templateName));
  }

  getTnaDefaultStepsLoader() {
    return this.store.pipe(select(TnaTemplateSelectors.GetTnaDefaultStepsLoader));
  }

  getTnaTemplateList() {
    return this.store.pipe(select(TnaTemplateSelectors.GetTnaTemplateList));
  }

  getUserPaginationOption() {
    return this.store.pipe(select(TnaTemplateSelectors.GetUserPaginationOption));
  }

  getTnADefaultSteps() {
    return this.store.pipe(select(TnaTemplateSelectors.GetTnaDefaultSteps));
  }

  getTnaTemplateDetails() {
    return this.store.pipe(select(TnaTemplateSelectors.GetTnaTemplateDetails));
  }

  assignTnaToOrder(payload: TREQUEST_ASSIGN_TNA_TO_ORDERS) {
    return this.store.dispatch(new TnaTemplateActions.AssignTnaToOrder(payload));
  }
}

export type TGetTnaTemplateList = ReturnType<TnaTemplatesFacade['getTnaTemplateList']>;
export type TGetTnaTemplatesUserPaginationOption = ReturnType<TnaTemplatesFacade['getUserPaginationOption']>;
export type TGetTnADefaultSteps = ReturnType<TnaTemplatesFacade['getTnADefaultSteps']>;
export type TGetTnATemplateDetails = ReturnType<TnaTemplatesFacade['getTnaTemplateDetails']>;
